import { createSlice } from "@reduxjs/toolkit";
import { fetchRoles, fetchUsers } from "../../pages/ATS/Workflow/workflowThunks"; 

const workflowSlice = createSlice({
  name: "workflow",
  initialState: {
    roles: [],
    users: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.roles = action.payload;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.users = action.payload;
      });
  },
});

export default workflowSlice.reducer;
